import { AxiosResponse } from 'axios';
import http from '../common/http';
import { Config } from '../components/AdminDashboard/Pages/CodeInjection/Interfaces/Config';

class ConfigService {
  getConfigs(): Promise<AxiosResponse> {
    return http.get(`/configs`);
  }
  updateConfig(config: Config): Promise<AxiosResponse> {
    return http.patch(`/configs/${config.id}`, { key: config.key, value: config.value });
  }
}

export default new ConfigService();
